import React, { useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { HotkeyInputProps } from './hotkey-input.types';
import { Input, InputRef } from 'antd';
import { Key } from '../key/key';
import './hotkey-input.scss';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

/*
All methods:
  https://www.npmjs.com/package/rc-input
  https://ant.design/components/input
*/
export const HotkeyInput = ({
  inputRef,
  hotkey = '',
  className,
  keyLabel,
  label,
  onPressEnter,
  onSearch,
  placeholder,
  suffix,
  onSearchClick,
  ...rest
}: HotkeyInputProps) => {
  const defaultRef = useRef<InputRef>(null);
  const inputRefInner = inputRef ?? defaultRef;

  const handleClick = (keyboardEvent: KeyboardEvent) => {
    keyboardEvent.preventDefault();
    inputRefInner?.current?.focus();
  };

  useHotkeys(hotkey, handleClick);

  const handleOnSearch = () => {
    if (onSearch) {
      onSearch(inputRefInner?.current?.input?.value?.trim() ?? '');
    }
  };

  const handleClickOnSearch = () => {
    if (onSearchClick) {
      onSearchClick(inputRefInner?.current?.input?.value?.trim() ?? '');
    }
  };

  // On Clear case
  const handleOnInput = (value: any) => {
    if (value.target.value?.length === 0) {
      if (onSearch) {
        onSearch(value.target.value.trim() ?? '');
      }
    }
  };

  return (
    <div className={`hotkey-input ${className ?? ''}`}>
      <Input
        ref={inputRefInner}
        placeholder={placeholder}
        onPressEnter={(event) => {
          handleOnSearch();
          if (onPressEnter) {
            onPressEnter(event);
          }
        }}
        onChange={handleOnInput}
        prefix={<SearchIcon onClick={handleClickOnSearch} />}
        suffix={
          <>
            {suffix}
            {keyLabel && <Key className={'hotkey-input__key'} value={keyLabel} />}
          </>
        }
        size="middle"
        {...rest}
      />
    </div>
  );
};
